import { useMutation } from "@tanstack/react-query";
import { generateWebSearch } from "../api/content.api";

export const useCreateContent = () => {
  const {
    mutate: createContent,
    isPending,
    data,
    error,
  } = useMutation({
    mutationFn: generateWebSearch,
  });

  return {
    createContent,
    isPending,
    data,
    error,
  };
};

